import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SContainer, SRow } from '@avalara/skylab-sdk/react';

import { hasProductAccess } from '../../lib/product-catalog';
import CatalogCard from './catalog-card';
import EventsSection from './events-section';
import productCatalogData from './product-catalog-data.json';

import type { ProductCatalogItem } from '../../../../types/product-catalog';
import type { Obligation } from '../../../../types/ztb';

const products = productCatalogData.products as Array<ProductCatalogItem>;

type Props = {
  obligations: Array<Obligation>;
  onContactClick: (item: ProductCatalogItem) => void;
  recommendedProductIds?: Array<string>;
  showRecommendationEvents?: boolean;
};

const ProductCatalogGrid = ({
  obligations,
  onContactClick,
  recommendedProductIds = [],
  showRecommendationEvents = false,
}: Props) => {
  const recommendedProducts = recommendedProductIds
    .map((id) => products.find((product) => product.id === id))
    .filter((product): product is ProductCatalogItem => product != null);

  return (
    <SContainer data-ref='buy.product-catalog.container'>
      <SRow>
        <SCol>
          <h1 data-ref='buy.product-catalog.header'>{t('client.headings.product-catalog')}</h1>
        </SCol>
      </SRow>
      {recommendedProducts.length > 0 && (
        <>
          <SRow>
            <SCol>
              <h2 data-ref='buy.product-catalog.recommended.header'>
                {t('client.product-catalog.recommended-heading')}
              </h2>
              <p data-ref='buy.product-catalog.recommended.subheader'>
                {t('client.product-catalog.recommended-subheading')}
              </p>
            </SCol>
          </SRow>
          <SRow>
            {recommendedProducts.map((product) => (
              <SCol key={product.id} data-ref={`buy.product-catalog.recommended.${product.slug}.tile`} span='6'>
                <CatalogCard
                  item={product}
                  hasAccess={hasProductAccess(product.productCatalogId, obligations)}
                  onContactClick={onContactClick}
                />
              </SCol>
            ))}
          </SRow>
        </>
      )}
      {showRecommendationEvents && <EventsSection />}
      <SRow>
        {products.map((product) => (
          <SCol key={product.id} data-ref={`buy.product-catalog.${product.slug}.tile`} span='6'>
            <CatalogCard
              item={product}
              hasAccess={hasProductAccess(product.productCatalogId, obligations)}
              onContactClick={onContactClick}
            />
          </SCol>
        ))}
      </SRow>
    </SContainer>
  );
};

export default ProductCatalogGrid;
